import posthog from 'posthog-js';

let isInitialized = false;

/**
 * Initialize PostHog analytics
 */
export const initPostHog = () => {
    if (isInitialized) {
        return;
    }

    const apiKey = process.env.REACT_APP_POSTHOG_API_KEY;
    const endpoint = process.env.REACT_APP_POSTHOG_ENDPOINT;

    if (!apiKey || !endpoint) {
        console.warn('PostHog: API key or endpoint not configured');
        return;
    }

    try {
        posthog.init(apiKey, {
            api_host: endpoint,
            loaded: (posthog) => {
                // Register platform super property to distinguish from mobile apps
                posthog.register({ platform: 'Web' });

                if (process.env.NODE_ENV === 'development') {
                    console.log('PostHog initialized successfully');
                }
            },
            capture_pageview: true,
            capture_pageleave: true,
        });

        isInitialized = true;
    } catch (error) {
        console.error('PostHog initialization error:', error);
    }
};

/**
 * Identify a user in PostHog
 * @param {string} userId - The unique user ID
 * @param {object} userProperties - Additional user properties
 */
export const identifyUser = (userId, userProperties = {}) => {
    try {
        posthog.identify(userId, userProperties);
    } catch (error) {
        console.error('PostHog identify error:', error);
    }
};

/**
 * Track a custom event in PostHog
 * @param {string} eventName - The name of the event
 * @param {object} properties - Event properties
 */
export const trackEvent = (eventName, properties = {}) => {
    try {
        posthog.capture(eventName, {
            ...properties,
            timestamp: new Date().toISOString(),
        });

        if (process.env.NODE_ENV === 'development') {
            console.log(`PostHog event tracked: ${eventName}`, properties);
        }
    } catch (error) {
        console.error('PostHog tracking error:', error);
    }
};

/**
 * Reset PostHog (e.g., on logout)
 */
export const resetPostHog = () => {
    try {
        posthog.reset();
    } catch (error) {
        console.error('PostHog reset error:', error);
    }
};

/**
 * Get PostHog instance
 */
export const getPostHog = () => {
    return posthog;
};

const posthogService = {
    initPostHog,
    identifyUser,
    trackEvent,
    resetPostHog,
    getPostHog,
};

export default posthogService;
